import styled from 'styled-components';

export const Container = styled.div`
  --ink: #202c35;
  --muted: #65727b;
  --line: #d9e0e2;
  --red: #bd4449;
  --blue: #287a9b;
  --green: #43856c;

  min-height: calc(100vh - 56px);
  background: #f2f5f3;
  color: var(--ink);
  padding: 18px 28px 32px;

  .preview-banner {
    display: grid;
    grid-template-columns: auto minmax(240px, 1fr) auto;
    align-items: center;
    gap: 24px;
    max-width: 1440px;
    margin: 0 auto 20px;
    padding: 13px 18px;
    border: 1px solid #d4a35b;
    border-left: 5px solid #d08d32;
    background: #fff8e9;
  }

  .preview-banner > div {
    display: grid;
    gap: 2px;
  }

  .eyebrow,
  .corner-label,
  .preview-tag,
  .fight-number,
  .sample-label,
  .preview-footer,
  .state-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0;
  }

  .eyebrow,
  .state-label {
    color: var(--muted);
  }

  .preview-banner strong {
    font-size: 18px;
  }

  .preview-banner p {
    margin: 0;
    color: #645637;
    font-size: 13px;
    line-height: 1.45;
  }

  .preview-tag,
  .sample-label {
    border: 1px solid #d9c89e;
    padding: 7px 9px;
    color: #775d27;
    white-space: nowrap;
  }

  .scout-preview {
    max-width: 1440px;
    margin: 0 auto;
  }

  .event-heading {
    display: flex;
    justify-content: space-between;
    align-items: end;
    gap: 16px;
    padding: 8px 0 18px;
    border-bottom: 1px solid var(--line);
  }

  .event-heading h1 {
    margin-top: 5px;
    font-size: 22px;
    font-weight: 700;
  }

  .fight-number {
    color: var(--muted);
    padding-bottom: 3px;
  }

  .fight-layout {
    display: grid;
    grid-template-columns: minmax(260px, 1fr) minmax(300px, 0.9fr) minmax(260px, 1fr);
    align-items: stretch;
    gap: 16px;
    padding: 20px 0;
  }

  .corner-panel,
  .fight-center,
  .action-log {
    border: 1px solid var(--line);
    background: #fff;
  }

  .corner-panel {
    min-width: 0;
    border-top: 4px solid var(--red);
  }

  .corner-panel.blue {
    border-top-color: var(--blue);
  }

  .corner-panel header {
    padding: 16px 18px 14px;
    border-bottom: 1px solid var(--line);
  }

  .corner-label {
    color: var(--red);
  }

  .corner-panel.blue .corner-label {
    color: var(--blue);
  }

  .corner-panel h2 {
    margin-top: 7px;
    font-size: 21px;
    font-weight: 700;
  }

  .corner-panel header p {
    margin-top: 4px;
    color: var(--muted);
    font-size: 13px;
  }

  .metric-list {
    display: grid;
    gap: 17px;
    padding: 18px;
  }

  .metric {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px 12px;
    align-items: center;
    font-size: 13px;
  }

  .metric > span {
    color: var(--muted);
  }

  .metric strong {
    font-size: 14px;
  }

  .metric-track {
    grid-column: 1 / -1;
    height: 5px;
    background: #e9edef;
  }

  .metric-track i {
    display: block;
    width: 38%;
    height: 100%;
    background: var(--red);
  }

  .corner-panel.blue .metric-track i {
    width: 52%;
    background: var(--blue);
  }

  .disabled-actions {
    display: flex;
    gap: 7px;
    padding: 0 18px 18px;
  }

  .disabled-actions button,
  .round-picker button {
    min-height: 34px;
    border: 1px solid var(--line);
    background: #f3f5f5;
    color: #879197;
    padding: 0 10px;
    font-size: 12px;
  }

  .fight-center {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
    text-align: center;
  }

  .timer {
    padding: 12px 8px;
    background: #26343c;
    color: #fff;
    font-size: 38px;
    font-variant-numeric: tabular-nums;
    font-weight: 300;
  }

  .fight-status {
    margin-top: 8px;
    padding: 8px;
    background: #dce8e3;
    color: #315c4b;
    font-size: 12px;
    font-weight: 700;
  }

  .fighters {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 10px;
    align-items: center;
    margin: 24px 0;
    font-size: 13px;
  }

  .fighters span {
    color: #89949a;
    font-size: 11px;
    font-weight: 700;
  }

  .state-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 14px 0;
    border-top: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
  }

  .state-row > *:nth-child(odd) {
    grid-column: span 1;
  }

  .state-row strong {
    padding: 8px;
    background: #e8a044;
    color: #fff;
    font-size: 13px;
  }

  .state-row .neutral {
    background: #75858c;
  }

  .round-picker {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
    color: var(--muted);
    font-size: 12px;
  }

  .legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px 14px;
    margin-top: auto;
    padding-top: 22px;
    color: var(--muted);
    font-size: 11px;
  }

  .legend span {
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }

  .legend i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .red-dot { background: var(--red); }
  .blue-dot { background: var(--blue); }
  .green-dot { background: var(--green); }

  .action-log {
    margin-top: 2px;
  }

  .section-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 15px 18px;
    border-bottom: 1px solid var(--line);
  }

  .section-heading h2 {
    margin-top: 4px;
    font-size: 17px;
    font-weight: 700;
  }

  .action-log ol {
    list-style: none;
  }

  .action-log li {
    display: grid;
    grid-template-columns: 70px minmax(120px, 0.8fr) minmax(180px, 1.5fr);
    gap: 14px;
    align-items: center;
    min-height: 50px;
    padding: 10px 18px;
    border-bottom: 1px solid #edf0f0;
    font-size: 13px;
  }

  .action-log li:last-child {
    border-bottom: 0;
  }

  .action-log time {
    color: var(--muted);
    font-variant-numeric: tabular-nums;
  }

  .action-log li strong {
    border-left: 3px solid var(--red);
    padding-left: 9px;
  }

  .action-log li.blue-action strong {
    border-left-color: var(--blue);
  }

  .action-log li span {
    color: var(--muted);
  }

  .preview-footer {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 0 0;
    color: var(--muted);
  }

  @media (max-width: 900px) {
    padding: 14px 16px 28px;

    .fight-layout {
      grid-template-columns: 1fr 1fr;
    }

    .fight-center {
      grid-column: 1 / -1;
      grid-row: 1;
    }
  }

  @media (max-width: 620px) {
    padding: 10px 12px 24px;

    .preview-banner {
      grid-template-columns: 1fr auto;
      gap: 8px 12px;
      padding: 12px;
    }

    .preview-banner p {
      grid-column: 1 / -1;
      grid-row: 2;
    }

    .event-heading {
      align-items: start;
      flex-direction: column;
      gap: 8px;
    }

    .event-heading h1 {
      font-size: 19px;
    }

    .fight-layout {
      grid-template-columns: 1fr;
      gap: 12px;
      padding: 12px 0;
    }

    .fight-center {
      grid-column: auto;
      grid-row: auto;
    }

    .corner-panel h2 {
      font-size: 19px;
    }

    .action-log li {
      grid-template-columns: 48px 1fr;
      gap: 5px 10px;
      padding: 10px 12px;
    }

    .action-log li span {
      grid-column: 2;
    }

    .section-heading {
      align-items: start;
      padding: 13px 12px;
    }

    .preview-footer {
      flex-direction: column;
    }
  }
`;